<mat-sidenav-container class="sidenav">
  <mat-sidenav #sidenav [opened]="model.open" (keydown.escape)="close()" mode="over" fixedInViewport="true"
    position="end">
    <div #header class="sidenav-header header-title" fxFlex="none" fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <div>{{ "flows.list.title" | translate }}</div>
        <div> / </div>
        <div class="second-text">{{ "flows.cancelAbTest.title" | translate }}</div>
      </div>
      <div class="close" (click)="close()" color="warn" fxLayoutAlign="center center">
        <mat-icon aria-hidden="false" aria-label="Filter">close</mat-icon>
      </div>
    </div>
    <div appearance="outlined" fxLayout="column" fxLayoutAlign="center center" class="cancel-ab-container">
      <mat-card>
        <div *ngIf="!isSelected">
          <div class="title" fxLayout="row" fxLayoutAlign="center center">
            {{ "flows.cancelAbTest.cancelTest" | translate }}
          </div>
          <div class="inputs-div">
            <div class="inputs" [ngClass]="{'input-selected': selectedOption === 1}" (click)="setOnlyOne(1)">
              <div class="infos">
                <div class="circle a">A</div>
                <div fxFlex fxLayout="column" fxLayoutGap="5px">
                  <div class="value">{{ model.flow_version.flows_descriptor[1].name }}</div>
                  <div class="subtitle">{{model.flow_version.flows_descriptor[1].description}} </div>
                </div>
              </div>
              <mat-checkbox color="primary" class="ml-2" [checked]="selectedOption === 1" (change)="setOnlyOne(1)">
              </mat-checkbox>
            </div>
            <div class="inputs" [ngClass]="{'input-selected': selectedOption === 2}" (click)="setOnlyOne(2)">
              <div class="infos">
                <div class="circle b">B</div>
                <div fxFlex fxLayout="column" fxLayoutGap="5px">
                  <div class="value">{{model.flow_version.flows_descriptor[2].name}}</div>
                  <div class="subtitle">{{model.flow_version.flows_descriptor[2].description}} </div>
                </div>
              </div>
              <mat-checkbox color="primary" class="ml-2" [checked]="selectedOption === 2" (change)="setOnlyOne(2)">
              </mat-checkbox>
            </div>

          </div>
        </div>

        <div class="selected" *ngIf="isSelected">
          <div class="header-div">
            <div class="circle" fxLayout="row" fxLayoutAlign="center center">
              <mat-icon aria-hidden="false" aria-label="action" svgIcon="icon_check" class="icon">
              </mat-icon>
            </div>
          </div>
          <div fxLayout="column" class="sucess-selected" fxLayoutAlign="center center">
            <div class="fc-3 fs-20 mb-3 mt-3 sucess" fxLayout="row" fxLayoutAlign="center center">
              {{ "flows.cancelAbTest.close_sucess" | translate }}
            </div>
            <div class="fc-9 fs-16 sucess-subtitle" fxLayout="row" fxLayoutAlign="center center">
              {{ "flows.cancelAbTest.close_sucess_subtitle" | translate }}
            </div>
          </div>

          <div class="inputs-div">
            <div class="inputs" *ngIf="selectedOption === 1">
              <div class="infos">
                <div class="circle a">A</div>
                <div fxFlex fxLayout="column" fxLayoutGap="5px">
                  <div class="value">{{model.flow_version.flows_descriptor[1].name}}</div>
                  <div class="subtitle">{{model.flow_version.flows_descriptor[1].description}}</div>
                </div>
              </div>
            </div>
            <div class="inputs" *ngIf="selectedOption === 2">
              <div class="infos">
                <div class="circle b">B</div>
                <div fxFlex fxLayout="column" fxLayoutGap="5px">
                  <div class="value">{{model.flow_version.flows_descriptor[2].name}}</div>
                  <div class="subtitle">{{model.flow_version.flows_descriptor[2].description}} </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between center" class="buttons">
          <button mat-stroked-button class="btn-secondary" *ngIf="isSelected" (click)="seeFlows()">
            <span>{{ "flows.cancelAbTest.buttons.seeFlows" | translate }}</span>
          </button>

          <button class="cancel-test-ab-btn" *ngIf="isSelected" fxLayout="row" fxFlex.lt-md="100" fxLayoutAlign="end"
            fxLayout="row" mat-flat-button color="primary" (click)="publish()">
            {{ "flows.cancelAbTest.buttons.publish" | translate }}
          </button>

          <button mat-stroked-button class="btn-secondary" *ngIf="!isSelected" (click)="close()">
            <span>{{ "flows.cancelAbTest.buttons.back" | translate }}</span>
          </button>

          <button [disabled]="!selectedOption" class="cancel-test-ab-btn" type="submit" fxLayout="row"
            fxFlex.lt-md="100" *ngIf="!isSelected" fxLayoutAlign="center end" fxLayout="row" mat-flat-button
            color="primary" (click)="cancelTestAb()">
            {{ "flows.cancelAbTest.buttons.cancel" | translate }}
          </button>
          <!--
          <button mat-stroked-button class="btn-secondary" *ngIf="isSelected" (click)="changeVersion()">
            <span>{{ "flows.cancelAbTest.buttons.changeVersion" | translate }}</span>
          </button>
-->

        </div>
      </mat-card>

      <div>
        <div class="obs">{{ "flows.cancelAbTest.obs.title" | translate }}</div>
      </div>

    </div>
  </mat-sidenav>
</mat-sidenav-container>
